import { createUseStyles } from 'react-jss'

import { card } from '../../../../../../../styles/common'
import { lightGrey, mediumGrey } from '../../../../../../../styles/const/colors'
import { textEllipsisMultiline } from '../../../../../../../styles/mixins/text'
import { transitionShort } from '../../../../../../../styles/const/common'

const useStyles = createUseStyles(theme => ({
  facebookPost: {
    height: 66,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    extend: card,
    borderColor: props => (props.isSelected ? theme.brandPrimary : lightGrey),
    transition: transitionShort,
    cursor: 'pointer',
    filter: 'unset',
    padding: '8px',
    marginTop: 8,
    '&:first-of-type': {
      marginTop: 16
    },
    '&:hover': {
      borderColor: props => (props.isSelected ? theme.brandPrimary : theme.brandPrimaryLight)
    }
  },
  body: {
    flex: 1,
    alignSelf: 'stretch'
  },
  postId: {
    fontSize: 10,
    color: mediumGrey,
    marginBottom: 3
  },
  postText: {
    ...textEllipsisMultiline(2),
    marginTop: [0, '!important']
  },
  shareBtn: {
    cursor: 'pointer',
    fontSize: 20
  },
  previewArea: {
    width: 60
  },
  preview: {
    objectFit: 'cover',
    borderRadius: 4,
    maxWidth: 50,
    maxHeight: 50
  }
}))

export default useStyles
